module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_5010.8b0851b6.png";